<template>
  <div class="trip-route-details">
    <base-loader v-if="dataIsLoading" />

    <div v-else class="content-wrapper">
      <!-- Карта -->
      <div
        class="map-wrapper"
        v-if="
          tripSummary &&
          tripSummary.total_distance_km != null &&
          tripSummary.total_time_minutes != null
        "
      >
        <TripRouteMap :route-legs="routeLegs" />
      </div>

      <!-- Итоги и детализация -->
      <div class="summary-container">
        <!-- Общие итоги -->
        <div
          class="total-summary"
          v-if="
            tripSummary &&
            tripSummary.total_distance_km != null &&
            tripSummary.total_time_minutes != null
          "
        >
          <div class="total-item">
            <span class="total-label">Всего км:</span>
            <span class="total-value">
              {{ formatDistance(tripSummary.total_distance_km) }}
            </span>
          </div>

          <div class="total-item">
            <span class="total-label">Всего времени:</span>
            <span class="total-value">
              {{ formatDuration(tripSummary.total_time_minutes) }}
            </span>
          </div>

          <base-primary-button
            class="total-btn"
            :disabled="dataIsLoading"
            @click="generateSummaries"
          >
            Обновить данные
          </base-primary-button>
        </div>

        <div class="empty-message" v-else>
          <span>Нет данных о маршруте</span>
          <base-primary-button
            class="empty-btn"
            :disabled="dataIsLoading"
            @click="generateSummaries"
          >
            Обновить данные
          </base-primary-button>
        </div>

        <!-- Список сегментов (Legs) -->
        <RouteLegsInfo
          v-if="routeLegs.length"
          :legs="normalizedLegs"
        />
      </div>
    </div>
  </div>
</template>

<script>
import tripRoutesApi from "@/services/api/tripRoutesApi";

import RouteLegsInfo from "@/components/RouteLegsInfo.vue";
import TripRouteMap from "@/components/Trip/TripRouteMap.vue";

export default {
  name: "TripRouteDetails",

  components: {
    RouteLegsInfo,
    TripRouteMap,
  },

  props: {
    tripId: {
      type: [Number, String],
      required: true,
    },
    companyId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      dataIsLoading: true,
      routeLegs: [],
      tripSummary: null,
    };
  },
  computed: {
    normalizedLegs() {
      return this.routeLegs.map((leg, index) => ({
        distance_km: leg.distance_km,
        time_minutes: leg.time_minutes,
        fromLabel: leg.trip_point_from?.sequence_number ?? index + 1,
        toLabel: leg.trip_point_to?.sequence_number ?? index + 2,
        fromAddress: leg.trip_point_from?.address || null,
        toAddress: leg.trip_point_to?.address || null,
      }));
    },
  },
  methods: {
    formatDistance(km) {
      if (!km && km !== 0) return "—";
      return `${Number(km).toFixed(1)} км`;
    },

    formatDuration(minutes) {
      if (!minutes && minutes !== 0) return "—";
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      if (hours === 0) return `${mins} мин`;
      return `${hours} ч ${mins} мин`;
    },

    async loadData() {
      this.dataIsLoading = true;

      try {
        const [legsResponse, summariesResponse] = await Promise.all([
          tripRoutesApi.index(this.companyId, this.tripId),
          tripRoutesApi.summariesIndex(this.companyId, this.tripId),
        ]);

        const legs = legsResponse.data.result || [];
        this.routeLegs = legs.sort((a, b) => {
          const seqA = a.trip_point_from?.sequence_number || 0;
          const seqB = b.trip_point_from?.sequence_number || 0;
          return seqA - seqB;
        });

        const summariesResult = summariesResponse.data.result;
        this.tripSummary = Array.isArray(summariesResult)
          ? summariesResult[0]
          : summariesResult;
      } catch (error) {
        console.error(
          "Ошибка при загрузке данных маршрута рейса:",
          error
        );
      } finally {
        this.dataIsLoading = false;
      }
    },

    async generateSummaries() {
      this.dataIsLoading = true;

      try {
        await tripRoutesApi.generateSummaries(
          this.companyId,
          this.tripId
        );

        await this.loadData();
      } catch (error) {
        console.error(
          "Ошибка при генерации итогов маршрута рейса:",
          error
        );
      } finally {
        this.dataIsLoading = false;
      }
    },

  },
  async created() {
    await this.loadData();
  },
};
</script>

<style scoped>
.trip-route-details {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.map-wrapper {
  width: 100%;
  flex-shrink: 0;
}

.summary-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.total-summary {
  display: flex;
  gap: 20px;
  background-color: #fff;
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
}

.total-item {
  display: flex;
  flex-direction: column;
}

.total-label {
  margin-bottom: 5px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
}

.total-value {
  font-size: 18px;
  font-weight: 600;
}

.total-btn {
  margin-left: auto;
}

.empty-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--base-in-indent);
  color: #666;
  padding: 20px;
}
</style>
